/**
 * Keys must stay in sync with backend ClientModuleAccessHelper.KnownKeys.
 */
export const CLIENT_MODULES = [
  { key: 'dashboard', label: 'Dashboard', description: 'Main KPI dashboard and widgets.', icon: 'fas fa-chart-line' },
  { key: 'leads', label: 'Leads', description: 'Lead list, capture, import, and lead detail.', icon: 'fas fa-user-plus' },
  { key: 'assignedLeads', label: 'Assigned leads', description: 'Assignments, pipeline filters, edit assignment.', icon: 'fas fa-tasks' },
  { key: 'buyers', label: 'Buyers', description: 'Buyer CRM profiles and deals.', icon: 'fas fa-user-check' },
  { key: 'kanban', label: 'Kanban pipeline', description: 'Board view for assigned leads.', icon: 'fas fa-columns' },
  { key: 'pipelineStages', label: 'Pipeline stages', description: 'Configure pipeline stages.', icon: 'fas fa-stream' },
  { key: 'pendingFollowUps', label: 'Pending follow-ups', description: 'Overdue follow-up queue.', icon: 'fas fa-bell' },
  { key: 'propertyListing', label: 'Property listing', description: 'Inventory, bookings, property detail.', icon: 'fas fa-building' },
  { key: 'builders', label: 'Builders / partners', description: 'Channel partners & builders.', icon: 'fas fa-handshake' },
  { key: 'reports', label: 'Reports', description: 'Reports & analytics.', icon: 'fas fa-chart-bar' },
  { key: 'attendance', label: 'My attendance', description: 'Personal attendance.', icon: 'fas fa-calendar-check' },
  { key: 'teamAttendance', label: 'Team attendance', description: 'Admin team attendance overview.', icon: 'fas fa-users' },
  { key: 'employees', label: 'Employees', description: 'Register & manage tenant users.', icon: 'fas fa-id-badge' },
  { key: 'quickSupport', label: 'Quick support', description: 'Support request form.', icon: 'fas fa-headset' },
  { key: 'settings', label: 'Workspace settings', description: 'Workspace rules, notification engine, and employee management.', icon: 'fas fa-cog' },
  { key: 'notificationEngine', label: 'Notification engine', description: 'Scheduler settings, templates, queue, and delivery history.', icon: 'fas fa-bell' },
];

/** Path prefix → module key (first match wins). Used when guarding routes. */
export const PATH_MODULE_RULES = [
  [/^\/dashboard(?:\/|$)/i, 'dashboard'],
  [/^\/$/i, 'dashboard'],
  [/^\/filteredLeads/i, 'leads'],
  [/^\/(?:leads|addlead|editlead|importLeads|printlead)(?:\/|$)/i, 'leads'],
  [/^\/editfbintegration/i, 'leads'],
  [/^\/(?:leadassigned|addleadsassigned|editleadassigned|filteredDataEmployee|filteredDashboarddata|filterdata)(?:\/|$)/i, 'assignedLeads'],
  [/^\/(?:buyers)(?:\/|$)/i, 'buyers'],
  [/^\/kanban(?:\/|$)/i, 'kanban'],
  [/^\/pipeline-stages(?:\/|$)/i, 'pipelineStages'],
  [/^\/pendingfollowups(?:\/|$)/i, 'pendingFollowUps'],
  [/^\/(?:propertylisting|property\/|addproperty|editproperty)(?:\/|$)/i, 'propertyListing'],
  [/^\/(?:builders|addbuilder|editbuilder)(?:\/|$)/i, 'builders'],
  [/^\/reports(?:\/|$)/i, 'reports'],
  [/^\/attendance(?:\/|$)/i, 'attendance'],
  [/^\/team-attendance(?:\/|$)/i, 'teamAttendance'],
  [/^\/(?:registeruser|adduser|edituser)(?:\/|$)/i, 'employees'],
  [/^\/quicksupport(?:\/|$)/i, 'quickSupport'],
  [/^\/settings(?:\/|$)/i, 'settings'],
  [/^\/notification-engine(?:\/|$)/i, 'notificationEngine'],
];
